import {Component} from '@angular/core';
import {OrganizationRegistrationService} from './organization-registration.service';
import {environment} from '@environments/environment';


@Component({
    providers: [
        OrganizationRegistrationService
    ],
    selector: 'organization-registration',
    templateUrl: './organization-registration.component.html',
    styleUrls: ['./organization-registration.component.scss']
})
export class OrganizationRegistrationComponent {
    public isContur = true;

    public formData = null;

    public legalRulesUrl = environment.legalRulesUrl;

    setToManual() {
        this.isContur = false;
    }

    onSuccessInnCheck(data) {
        this.formData = data;
        this.setToManual();
    }
}
